var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{ref:"vSelect",staticClass:"w-full",attrs:{"options":_vm.categoriesConditionOptions,"multiple":false,"clearable":false,"close-on-select":"","getOptionLabel":(option) => this.$t(`$AppFilters.$Operation.${option}`)},model:{value:(_vm.valueLocal),callback:function ($$v) {_vm.valueLocal=$$v},expression:"valueLocal"}})
}
var staticRenderFns = []

export { render, staticRenderFns }